/** 手感时序常量 —— 集中可调 */
export const FEEL = {
  shootCooldownMs: 160,
  bulletSpeed: 520,        // px/s at design radius 160
  hostileSpeed: 380,
  /** 环内 2D 移速（设计半径 160 下 px/s） */
  playerSpeed: 300,
  floatScoreMs: 700,
  deathFreezeMs: 220,
  spawnIntervalMs: 1400,
  maxOrbs: 6,
  hitShakeMs: 100,
  hitShakePx: 4,
  scoreBase: 100,
  streakBonus: 25,
  /** 子弹累计成功弹射上限；第 2 次弹完后 life 压到 bounceFadeLife */
  maxBounces: 2,
  bounceFadeLife: 0.25,
  /** 元素球基半径（设计半径 160）；22×0.8=17.6 */
  orbRadius: 17.6,
  /** 土：在已缩基线上略大 */
  orbScaleTu: 1.22,
  /** 木分裂子球 */
  orbScaleChild: 0.55,
  /** 金：普通弹 2 血；设计空间弹速 ≥ 此值或已反弹弹 → 一击碎 */
  jinHp: 2,
  jinFastOneShot: 600,
  /** 水：折射偏转角（弧度）；2 血 */
  shuiHp: 2,
  shuiDeflect: 0.4,
  shuiDrift: 36,
  /** 火：得分倍率；灼烧溅射半径（设计 160） */
  huoScoreMul: 1.6,
  burnRadius: 58,
  burnMs: 420,
  /** 土：2 血挡弹 */
  tuHp: 2,
  playerSize: 16,
  ringThickness: 18,
};
